import {ApiAlertsResponseType} from "./types";
import {AxiosResponse} from "axios";
import {axiosProvider as axios} from "app/axiosProvider";

export const apiGetAlerts = (): Promise<AxiosResponse<ApiAlertsResponseType>> => axios.post("/get-alerts");